export const SHOW_CREATE_REQUEST_MODAL = "SHOW_CREATE_REQUEST_MODAL";
export const SHOW_EDIT_REQUEST_MODAL = "SHOW_EDIT_REQUEST_MODAL";
export const SET_REQUEST_CURRENT_ID = "SET_REQUEST_CURRENT_ID";
export const SHOW_EDIT_COMPANY_INFO = "SHOW_EDIT_COMPANY_INFO";
export const SHOW_EDIT_COMPANY_EXPERTISE = "SHOW_EDIT_COMPANY_EXPERTISE";